import { useEffect, useState, useCallback, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import CadastroEmailsClienteModal from '../components/CadastroEmailsClienteModal'
import { useEmpresa } from '../contexts/EmpresaContext'

interface NFSeRow {
  empcod:       number
  serie:        string
  numero:       number
  cnpj_tomador: string
  nome_tomador: string
  desc_serv:    string
  data_compet:  string
  valor_total:  string
  sitnfe:       number
  chave_acesso: string
  xmotivo:      string
  tp_amb:       string
  data_emissao: string
}

interface Filtros {
  tomador:     string
  numero:      string
  dataInicio:  string
  dataFim:     string
  sitnfe:      string
}

const SIT: Record<number, { label: string; color: string; bg: string }> = {
  5: { label: 'Pendente',    color: '#b45309', bg: '#fef3c7' },
  6: { label: 'Autorizada',  color: '#15803d', bg: '#dcfce7' },
  4: { label: 'Rejeitada',   color: '#dc2626', bg: '#fee2e2' },
  7: { label: 'Cancelada',   color: '#dc2626', bg: '#fee2e2' },
}

function fmtDateInput(d: Date) { return d.toISOString().slice(0, 10) }
function fmtData(iso: string | null) {
  if (!iso) return '-'
  return iso.slice(0, 10).split('-').reverse().join('/')
}
function fmtMoeda(v: string | number) {
  const n = typeof v === 'string' ? parseFloat(v) : v
  if (isNaN(n)) return '—'
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}
function fmtCnpj(doc: string) {
  const n = (doc ?? '').replace(/\D/g, '')
  if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  return doc
}
function filtroPadrao(): Filtros {
  const hoje  = new Date()
  const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1)
  return { tomador: '', numero: '', dataInicio: fmtDateInput(inicio), dataFim: fmtDateInput(hoje), sitnfe: '' }
}

const inp: React.CSSProperties = {
  border: '1px solid #d1d5db', borderRadius: 4, padding: '4px 8px',
  fontSize: '0.82rem', height: 30, background: '#fff',
}

function kv(label: string, value: React.ReactNode) {
  return (
    <div>
      <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' as const, marginBottom: 1 }}>{label}</div>
      <div style={{ fontSize: '0.82rem', color: '#374151' }}>{value}</div>
    </div>
  )
}

function secTitle(title: string) {
  return (
    <div style={{ background: '#f3f4f6', borderTop: '1px solid #e5e7eb', borderBottom: '1px solid #e5e7eb', padding: '4px 1.25rem', fontSize: '0.7rem', fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' as const, letterSpacing: 0.5 }}>
      {title}
    </div>
  )
}

export default function ListaNFSeNacional() {
  const navigate = useNavigate()
  const { empresas, empresaCod } = useEmpresa()
  const [lista, setLista]           = useState<NFSeRow[]>([])
  const [carregando, setCarregando] = useState(true)
  const [erro, setErro]             = useState<string | null>(null)
  const [filtros, setFiltros]       = useState<Filtros>(filtroPadrao)
  const [ativos, setAtivos]         = useState<Filtros>(filtroPadrao)

  const [transmitindo, setTransmitindo] = useState<number | null>(null)
  const [msgTransmitir, setMsgTransmitir] = useState<{ numero: number; texto: string; ok: boolean } | null>(null)

  const [cancelando, setCancelando]     = useState(false)
  const [rowCancel, setRowCancel]       = useState<NFSeRow | null>(null)
  const [xJust, setXJust]              = useState('')
  const [cMotivo, setCMotivo]          = useState(1)
  const [erroCancel, setErroCancel]    = useState<string | null>(null)
  const justRef = useRef<HTMLTextAreaElement>(null)

  // Financeiro
  const [finRow, setFinRow]                       = useState<NFSeRow | null>(null)
  const [finExistente, setFinExistente]           = useState<{ numero: string; vencimento: string; valor: number; saldo: number; contaCod: string }[]>([])
  const [finCarregando, setFinCarregando]         = useState(false)
  const [finRetencao, setFinRetencao]             = useState(0)
  const [finQtd, setFinQtd]                       = useState(1)
  const [finIntervalo, setFinIntervalo]           = useState(30)
  const [finParcelas, setFinParcelas]             = useState<{ numero: string; vencimento: string; valor: string }[]>([])
  const [finContaCod, setFinContaCod]             = useState('')
  const [finContaNome, setFinContaNome]           = useState('')
  const [finContaBusca, setFinContaBusca]         = useState('')
  const [finContaResultados, setFinContaResultados] = useState<{ dep_cod: string; dep_des: string }[]>([])
  const [finContaAberto, setFinContaAberto]       = useState(false)
  const [finSalvando, setFinSalvando]             = useState(false)
  const [finDeletando, setFinDeletando]           = useState(false)
  const [finErro, setFinErro]                     = useState<string | null>(null)

  // Resumo / Consulta
  const [consultaRow, setConsultaRow]               = useState<NFSeRow | null>(null)
  const [consultaFinanceiro, setConsultaFinanceiro] = useState<{ numero: string; vencimento: string; valor: number; saldo: number; contaCod: string }[]>([])
  const [consultaDetalhes, setConsultaDetalhes]     = useState<any>(null)
  const [carregandoConsulta, setCarregandoConsulta] = useState(false)
  const [chaveCopiadaId, setChaveCopiadaId]         = useState<number | null>(null)

  const [acoesMenuId, setAcoesMenuId] = useState<number | null>(null)
  const [acoesMenuPos, setAcoesMenuPos] = useState<{ top: number; left: number } | null>(null)

  // Envio de e-mail
  const [emailModal, setEmailModal] = useState<NFSeRow | null>(null)
  const [emailCarregando, setEmailCarregando] = useState(false)
  const [emailEnviando, setEmailEnviando] = useState(false)
  const [emailErro, setEmailErro] = useState<string | null>(null)
  const [emailMsg, setEmailMsg] = useState<{ texto: string; ok: boolean } | null>(null)
  const [emailRemetenteNome, setEmailRemetenteNome] = useState('')
  const [emailRemetenteEmail, setEmailRemetenteEmail] = useState('')
  const [emailDestNome, setEmailDestNome] = useState('')
  const [emailDestCnpj, setEmailDestCnpj] = useState('')
  const [emailDestinatario, setEmailDestinatario] = useState('')
  const [emailCopias, setEmailCopias] = useState<string[]>([])
  const [cadEmailsAberto, setCadEmailsAberto] = useState(false)
  const [emailAssunto, setEmailAssunto] = useState('')
  const [emailCorpo, setEmailCorpo] = useState('')

  const carregar = useCallback(async () => {
    setCarregando(true)
    setErro(null)
    try {
      const params: Record<string, string> = { empcod: String(empresaCod ?? 1) }
      if (ativos.tomador)    params.tomador    = ativos.tomador
      if (ativos.numero)     params.numero     = ativos.numero
      if (ativos.dataInicio) params.dataInicio = ativos.dataInicio
      if (ativos.dataFim)    params.dataFim    = ativos.dataFim
      if (ativos.sitnfe)     params.sitnfe     = ativos.sitnfe
      const r = await api.get('/nfse-nacional/lista', { params })
      setLista(r.data)
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao carregar lista')
    } finally {
      setCarregando(false)
    }
  }, [ativos, empresaCod])

  useEffect(() => { carregar() }, [carregar])

  async function transmitir(row: NFSeRow) {
    setTransmitindo(row.numero)
    setMsgTransmitir(null)
    try {
      const r = await api.post(`/nfse-nacional/${row.numero}/retransmitir`, {}, { params: { empcod: row.empcod } })
      const res = r.data
      const texto = res.ok
        ? 'Autorizada!'
        : (res.xMotivo || res.erro || 'Rejeitada — sem motivo informado')
      setMsgTransmitir({ numero: row.numero, texto, ok: !!res.ok })
      await carregar()
    } catch (e: any) {
      setMsgTransmitir({ numero: row.numero, texto: e?.response?.data?.error || 'Erro ao transmitir', ok: false })
    } finally {
      setTransmitindo(null)
    }
  }

  function pesquisar() { setAtivos({ ...filtros }) }
  function limpar()    { const p = filtroPadrao(); setFiltros(p); setAtivos(p) }

  async function abrirFinanceiro(row: NFSeRow) {
    setFinRow(row)
    setFinExistente([])
    setFinParcelas([])
    setFinContaCod('')
    setFinContaNome('')
    setFinContaBusca('')
    setFinContaResultados([])
    setFinContaAberto(false)
    setFinErro(null)
    setFinCarregando(true)
    try {
      const r = await api.get(`/nfse-nacional/${row.numero}/financeiro?empcod=${row.empcod}`)
      setFinExistente(r.data.parcelas ?? [])
      setFinRetencao(Number(r.data.retencaoTotal ?? 0))
    } catch { /* sem financeiro ainda */ }
    finally { setFinCarregando(false) }
  }

  function fecharFinanceiro() {
    if (finSalvando || finDeletando) return
    setFinRow(null)
    setFinExistente([])
    setFinParcelas([])
    setFinContaCod('')
    setFinContaNome('')
    setFinContaBusca('')
    setFinContaResultados([])
    setFinContaAberto(false)
    setFinErro(null)
  }

  function recalcularParcelas(qtd: number, intervalo: number, row: NFSeRow) {
    const base  = new Date(row.data_compet)
    const total = parseFloat(String(row.valor_total))
    setFinParcelas(Array.from({ length: qtd }, (_, i) => {
      const d = new Date(base)
      d.setDate(d.getDate() + intervalo * (i + 1))
      return {
        numero:     String(i + 1).padStart(2, '0'),
        vencimento: d.toISOString().slice(0, 10),
        valor:      (total / qtd).toFixed(2),
      }
    }))
  }

  async function buscarConta(cod: string) {
    if (!cod.trim()) return
    try {
      const r = await api.get('/erp/contas', { params: { busca: cod.trim() } })
      if (r.data.length === 1) {
        setFinContaCod(r.data[0].dep_cod.trim())
        setFinContaNome(r.data[0].dep_des)
      }
    } catch { /* */ }
  }

  async function salvarFinanceiroNfse() {
    if (!finRow) return
    if (finParcelas.length === 0) { setFinErro('Calcule as parcelas primeiro'); return }
    if (!finContaCod.trim()) { setFinErro('Informe a conta financeira'); return }
    setFinSalvando(true)
    setFinErro(null)
    try {
      await api.post(`/nfse-nacional/${finRow.numero}/financeiro?empcod=${finRow.empcod}`, {
        parcelas: finParcelas,
        contaCod: finContaCod,
        retencaoTotal: finRetencao,
      })
      const r = await api.get(`/nfse-nacional/${finRow.numero}/financeiro?empcod=${finRow.empcod}`)
      setFinExistente(r.data.parcelas ?? [])
      setFinParcelas([])
    } catch (e: any) {
      setFinErro(e?.response?.data?.error || 'Erro ao salvar financeiro')
    } finally { setFinSalvando(false) }
  }

  async function deletarFinanceiroNfse() {
    if (!finRow) return
    setFinDeletando(true)
    setFinErro(null)
    try {
      await api.delete(`/nfse-nacional/${finRow.numero}/financeiro?empcod=${finRow.empcod}`)
      setFinExistente([])
    } catch (e: any) {
      setFinErro(e?.response?.data?.error || 'Erro ao excluir financeiro')
    } finally { setFinDeletando(false) }
  }

  function copiarChave(chave: string, numero: number) {
    try {
      const el = document.createElement('textarea')
      el.value = chave
      el.style.cssText = 'position:fixed;opacity:0;top:0;left:0'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      setChaveCopiadaId(numero)
      setTimeout(() => setChaveCopiadaId(null), 2000)
    } catch {}
  }

  async function abrirConsulta(row: NFSeRow) {
    setConsultaRow(row)
    setConsultaFinanceiro([])
    setConsultaDetalhes(null)
    setCarregandoConsulta(true)
    try {
      const [finR, detR] = await Promise.all([
        api.get(`/nfse-nacional/${row.numero}/financeiro?empcod=${row.empcod}`).catch(() => null),
        api.get(`/nfse-nacional/${row.numero}/detalhes?empcod=${row.empcod}`).catch(() => null),
      ])
      setConsultaFinanceiro(finR?.data?.parcelas ?? [])
      setConsultaDetalhes(detR?.data ?? null)
    } finally { setCarregandoConsulta(false) }
  }

  function fecharConsulta() {
    setConsultaRow(null)
    setConsultaFinanceiro([])
    setConsultaDetalhes(null)
  }

  function toggleMenuAcoes(e: React.MouseEvent, id: number) {
    if (acoesMenuId === id) { setAcoesMenuId(null); setAcoesMenuPos(null); return }
    const rect = (e.currentTarget as HTMLButtonElement).getBoundingClientRect()
    setAcoesMenuId(id)
    setAcoesMenuPos({ top: rect.bottom + 2, left: rect.left })
  }
  function fecharMenuAcoes() { setAcoesMenuId(null); setAcoesMenuPos(null) }

  const menuItemStyle: React.CSSProperties = {
    display: 'block', width: '100%', textAlign: 'left', padding: '7px 12px',
    fontSize: '0.78rem', color: '#1f2937', background: 'none', border: 'none',
    cursor: 'pointer', whiteSpace: 'nowrap',
  }
  const onMenuHover = (e: React.MouseEvent<HTMLElement>) => (e.currentTarget.style.background = '#f3f4f6')
  const onMenuLeave = (e: React.MouseEvent<HTMLElement>) => (e.currentTarget.style.background = '')

  async function abrirEmail(row: NFSeRow) {
    setEmailModal(row); setEmailErro(null); setEmailMsg(null); setEmailCarregando(true)
    setEmailRemetenteNome(''); setEmailRemetenteEmail('')
    setEmailDestNome(''); setEmailDestCnpj(''); setEmailDestinatario('')
    setEmailCopias([]); setEmailAssunto(''); setEmailCorpo('')
    try {
      const r = await api.get(`/nfse-nacional/${row.numero}/email-preview?empcod=${row.empcod}`)
      const d = r.data
      setEmailRemetenteNome(d.remetenteNome ?? '')
      setEmailRemetenteEmail(d.remetenteEmail ?? '')
      setEmailDestNome(d.destinatarioNome ?? '')
      setEmailDestCnpj(d.destinatarioCnpj ?? '')
      setEmailDestinatario(d.destinatarioEmail ?? '')
      setEmailCopias(d.copias ?? [])
      setEmailAssunto(d.assunto ?? '')
      setEmailCorpo(d.corpo ?? '')
    } catch (e: any) {
      setEmailErro(e?.response?.data?.error || 'Erro ao carregar dados de e-mail')
    } finally {
      setEmailCarregando(false)
    }
  }

  function fecharEmail() { if (emailEnviando) return; setEmailModal(null) }

  function removerCopiaEmail(idx: number) {
    setEmailCopias(cs => cs.filter((_, i) => i !== idx))
  }

  async function enviarEmailNota() {
    if (!emailModal) return
    if (!emailDestinatario.trim()) { setEmailErro('Informe o e-mail do destinatário'); return }
    setEmailEnviando(true); setEmailErro(null)
    try {
      await api.post(`/nfse-nacional/${emailModal.numero}/enviar-email?empcod=${emailModal.empcod}`, {
        destinatario: emailDestinatario.trim(),
        copias: emailCopias.map(c => c.trim()).filter(Boolean),
        assunto: emailAssunto,
        corpo: emailCorpo,
      })
      setEmailMsg({ texto: 'E-mail enviado com sucesso!', ok: true })
      setEmailModal(null)
    } catch (e: any) {
      setEmailErro(e?.response?.data?.error || 'Erro ao enviar e-mail')
    } finally {
      setEmailEnviando(false)
    }
  }

  async function confirmarCancelamento() {
    if (!rowCancel) return
    if (xJust.trim().length < 15) { setErroCancel('Justificativa deve ter no mínimo 15 caracteres'); return }
    setCancelando(true)
    setErroCancel(null)
    try {
      const r = await api.post(`/nfse-nacional/${rowCancel.numero}/cancelar?empcod=${rowCancel.empcod}`, { xJust: xJust.trim(), cMotivo })
      if (r.data.cancelado) {
        setRowCancel(null)
        setXJust('')
        carregar()
      } else {
        setErroCancel(r.data.xMotivo || r.data.erro || 'Erro ao cancelar')
      }
    } catch (e: any) {
      setErroCancel(e?.response?.data?.error || e?.response?.data?.xMotivo || 'Erro ao cancelar')
    } finally {
      setCancelando(false)
    }
  }

  return (
    <div>
      {/* Modal de envio de e-mail */}
      {emailModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }} onClick={fecharEmail}>
          <div style={{
            background: '#fff', borderRadius: 8, padding: '1.5rem',
            width: 560, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 0.25rem', fontSize: '1rem', fontWeight: 700, color: '#1d4ed8' }}>
              Enviar XML/PDF por E-mail
            </h3>
            <p style={{ margin: '0 0 1rem', fontSize: '0.82rem', color: '#6b7280' }}>
              Nº {emailModal.numero} — {fmtCnpj(String(emailModal.cnpj_tomador ?? ''))}
            </p>

            {emailCarregando ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af' }}>Carregando...</div>
            ) : (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.4rem 1rem', marginBottom: '0.75rem' }}>
                  {kv('Remetente', emailRemetenteNome || '—')}
                  {kv('E-mail Remetente', emailRemetenteEmail || '—')}
                </div>

                {kv('Destinatário', `${emailDestNome}${emailDestCnpj ? ' — ' + fmtCnpj(emailDestCnpj) : ''}`)}

                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', display: 'block', margin: '0.6rem 0 4px' }}>
                  E-mail do Destinatário
                </label>
                <input value={emailDestinatario} onChange={e => setEmailDestinatario(e.target.value)}
                  placeholder="email@exemplo.com"
                  style={{
                    width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db',
                    borderRadius: 4, padding: '6px 8px', fontSize: '0.85rem',
                  }} />

                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', display: 'block', margin: '0.75rem 0 4px' }}>
                  Cópias
                </label>
                {emailCopias.length === 0 && (
                  <div style={{ fontSize: '0.78rem', color: '#9ca3af', marginBottom: 4 }}>Nenhuma cópia cadastrada</div>
                )}
                {emailCopias.map((c, idx) => (
                  <div key={idx} style={{ display: 'flex', gap: 6, marginBottom: 4 }}>
                    <input value={c}
                      onChange={e => setEmailCopias(cs => cs.map((v, i) => i === idx ? e.target.value : v))}
                      style={{ flex: 1, border: '1px solid #d1d5db', borderRadius: 4, padding: '5px 8px', fontSize: '0.82rem' }} />
                    <button onClick={() => removerCopiaEmail(idx)}
                      title="Remover desta cópia (não altera o cadastro do cliente)"
                      style={{
                        background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5',
                        borderRadius: 4, padding: '0 10px', cursor: 'pointer',
                      }}>
                      ✕
                    </button>
                  </div>
                ))}

                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', display: 'block', margin: '0.75rem 0 4px' }}>
                  Assunto
                </label>
                <input value={emailAssunto} onChange={e => setEmailAssunto(e.target.value)}
                  style={{
                    width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db',
                    borderRadius: 4, padding: '6px 8px', fontSize: '0.85rem',
                  }} />

                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: '#374151', display: 'block', margin: '0.75rem 0 4px' }}>
                  Mensagem
                </label>
                <textarea value={emailCorpo} onChange={e => setEmailCorpo(e.target.value)} rows={5}
                  style={{
                    width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db',
                    borderRadius: 4, padding: '6px 8px', fontSize: '0.85rem', resize: 'vertical',
                  }} />

                {emailErro && <div style={{ color: '#dc2626', fontSize: '0.78rem', marginTop: 8 }}>{emailErro}</div>}

                <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
                  <button className="btn btn-sm" onClick={() => setCadEmailsAberto(true)} disabled={emailEnviando || !emailDestCnpj}
                    title="Cadastrar/alterar os e-mails deste cliente sem sair da tela"
                    style={{ marginRight: 'auto', color: '#1b3f7b', border: '1px solid #c7d6ea', background: '#eef3f9', fontWeight: 600 }}>
                    ✉ Cadastrar e-mails
                  </button>
                  {cadEmailsAberto && (
                    <CadastroEmailsClienteModal doc={emailDestCnpj} nome={emailDestNome} tipo="M"
                      onClose={() => setCadEmailsAberto(false)}
                      onSalvo={(principal, copias) => { setEmailDestinatario(principal); setEmailCopias(copias); setCadEmailsAberto(false) }} />
                  )}
                  <button className="btn btn-sm" onClick={fecharEmail} disabled={emailEnviando} style={{ color: '#6b7280' }}>
                    Voltar
                  </button>
                  <button onClick={enviarEmailNota}
                    disabled={emailEnviando || !emailDestinatario.trim()}
                    style={{
                      background: '#1d4ed8', color: '#fff', border: 'none',
                      borderRadius: 4, padding: '5px 16px', fontSize: '0.82rem',
                      fontWeight: 600, cursor: emailEnviando ? 'not-allowed' : 'pointer',
                      opacity: emailEnviando || !emailDestinatario.trim() ? 0.6 : 1,
                    }}>
                    {emailEnviando ? 'Enviando...' : 'Enviar E-mail'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Modal cancelamento */}
      {rowCancel && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
        }}>
          <div style={{
            background: '#fff', borderRadius: 8, padding: '1.5rem', width: 480, maxWidth: '90vw',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
          }}>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.5rem', color: '#dc2626' }}>
              Cancelar NFS-e Nacional
            </h3>
            <p style={{ fontSize: '0.82rem', color: '#6b7280', marginBottom: '1rem' }}>
              NFS-e <strong>Nº {rowCancel.numero}</strong> — Tomador: {fmtCnpj(String(rowCancel.cnpj_tomador))}
            </p>
            <div style={{ marginBottom: '0.75rem' }}>
              <label style={{ fontSize: '0.78rem', fontWeight: 600, display: 'block', marginBottom: 4 }}>
                Motivo do cancelamento
              </label>
              <select
                value={cMotivo}
                onChange={e => setCMotivo(Number(e.target.value))}
                style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: 4, padding: '6px 10px', fontSize: '0.82rem' }}
              >
                <option value={1}>1 — Erro na emissão</option>
                <option value={2}>2 — Serviço não prestado</option>
                <option value={9}>9 — Outros</option>
              </select>
            </div>
            <label style={{ fontSize: '0.78rem', fontWeight: 600, display: 'block', marginBottom: 4 }}>
              Justificativa (mín. 15 caracteres)
            </label>
            <textarea
              ref={justRef}
              value={xJust}
              onChange={e => { setXJust(e.target.value); setErroCancel(null) }}
              rows={4}
              style={{
                width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db',
                borderRadius: 4, padding: '6px 10px', fontSize: '0.82rem', resize: 'vertical',
              }}
              placeholder="Informe o motivo do cancelamento..."
            />
            <div style={{ fontSize: '0.72rem', color: xJust.trim().length < 15 ? '#dc2626' : '#6b7280', marginBottom: '0.75rem' }}>
              {xJust.trim().length}/15 mínimo
            </div>
            {erroCancel && (
              <div style={{ background: '#fee2e2', color: '#dc2626', borderRadius: 4, padding: '6px 10px', fontSize: '0.8rem', marginBottom: '0.75rem' }}>
                {erroCancel}
              </div>
            )}
            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
              <button
                onClick={() => { setRowCancel(null); setXJust(''); setErroCancel(null); setCMotivo(1) }}
                disabled={cancelando}
                style={{ padding: '0.4rem 1rem', border: '1px solid #d1d5db', borderRadius: 4, background: '#fff', fontSize: '0.82rem', cursor: 'pointer' }}>
                Voltar
              </button>
              <button
                onClick={confirmarCancelamento}
                disabled={cancelando || xJust.trim().length < 15}
                style={{
                  padding: '0.4rem 1rem', background: '#dc2626', color: '#fff',
                  border: 'none', borderRadius: 4, fontSize: '0.82rem', fontWeight: 600,
                  cursor: cancelando || xJust.trim().length < 15 ? 'not-allowed' : 'pointer',
                  opacity: cancelando ? 0.7 : 1,
                }}>
                {cancelando ? 'Cancelando...' : 'Confirmar cancelamento'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Financeiro */}
      {finRow && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
          display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
          zIndex: 1000, padding: '24px 12px',
        }} onClick={fecharFinanceiro}>
          <div style={{
            background: '#fff', borderRadius: 8, width: 560, maxWidth: '96vw',
            maxHeight: 'calc(100vh - 48px)', overflow: 'hidden', display: 'flex', flexDirection: 'column',
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
          }} onClick={e => e.stopPropagation()}>

            {/* Cabeçalho */}
            <div style={{ background: '#065f46', color: '#fff', padding: '0.85rem 1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: '1rem' }}>Financeiro — NFS-e Nacional</div>
                <div style={{ fontSize: '0.78rem', opacity: 0.85, marginTop: 2 }}>
                  Nº {finRow.numero} — {fmtCnpj(String(finRow.cnpj_tomador))} — R$ {fmtMoeda(finRow.valor_total)}
                </div>
              </div>
              <button onClick={fecharFinanceiro} style={{ background: 'rgba(255,255,255,0.18)', border: 'none', cursor: 'pointer', color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: '1rem' }}>✕</button>
            </div>

            {/* Corpo */}
            <div style={{ overflowY: 'auto', flex: 1, padding: '1rem 1.25rem' }}>
              {finCarregando ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: '#9ca3af' }}>Carregando...</div>
              ) : (
                <>
                  {/* Parcelas existentes */}
                  {finExistente.length > 0 && (
                    <div style={{ marginBottom: '1rem' }}>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#065f46', textTransform: 'uppercase', marginBottom: 6 }}>
                        Financeiro existente ({finExistente.length} parcela{finExistente.length > 1 ? 's' : ''})
                      </div>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                        <thead>
                          <tr className="thead-claro" style={{ background: '#f0fdf4' }}>
                            {['Nº', 'Vencimento', 'Valor', 'Saldo', 'Conta'].map(h => (
                              <th key={h} style={{ padding: '4px 8px', border: '1px solid #bbf7d0', color: '#065f46', fontWeight: 700, textAlign: h === 'Nº' ? 'center' : 'left' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {finExistente.map((p, i) => (
                            <tr key={i}>
                              <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'center' }}>{p.numero}</td>
                              <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0' }}>{fmtData(p.vencimento)}</td>
                              <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtMoeda(p.valor)}</td>
                              <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtMoeda(p.saldo)}</td>
                              <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', fontFamily: 'monospace', fontSize: '0.76rem' }}>{p.contaCod}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <button
                        onClick={deletarFinanceiroNfse}
                        disabled={finDeletando}
                        style={{
                          marginTop: '0.5rem', padding: '4px 12px', background: '#fee2e2', color: '#dc2626',
                          border: '1px solid #fca5a5', borderRadius: 4, fontSize: '0.8rem',
                          cursor: finDeletando ? 'not-allowed' : 'pointer', opacity: finDeletando ? 0.6 : 1,
                        }}>
                        {finDeletando ? 'Excluindo...' : 'Excluir financeiro'}
                      </button>
                    </div>
                  )}

                  <hr style={{ borderColor: '#e5e7eb', margin: '0.75rem 0' }} />

                  <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#374151', textTransform: 'uppercase', marginBottom: 10 }}>
                    {finExistente.length > 0 ? 'Substituir financeiro' : 'Criar financeiro'}
                  </div>

                  {/* Retenção INSS */}
                  <div style={{ marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.75rem', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 4, padding: '0.5rem 0.75rem' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#92400e', whiteSpace: 'nowrap' }}>Retenção INSS (R$)</label>
                    <input
                      type="number" min={0} step="0.01"
                      value={finRetencao}
                      onChange={e => setFinRetencao(Number(e.target.value))}
                      style={{ width: 100, border: '1px solid #fde68a', borderRadius: 4, padding: '4px 8px', fontSize: '0.85rem', background: '#fff' }}
                    />
                    <span style={{ fontSize: '0.72rem', color: '#92400e' }}>Descontado do saldo de cada parcela</span>
                  </div>

                  <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '0.75rem' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Qtd. Parcelas</label>
                      <input
                        type="number" min={1} max={36} value={finQtd}
                        onChange={e => { const v = Math.max(1, Number(e.target.value)); setFinQtd(v); recalcularParcelas(v, finIntervalo, finRow) }}
                        style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 4, padding: '5px 8px', fontSize: '0.85rem' }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Intervalo (dias)</label>
                      <input
                        type="number" min={1} value={finIntervalo}
                        onChange={e => { const v = Math.max(1, Number(e.target.value)); setFinIntervalo(v); recalcularParcelas(finQtd, v, finRow) }}
                        style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 4, padding: '5px 8px', fontSize: '0.85rem' }}
                      />
                    </div>
                  </div>

                  {/* Conta Financeira */}
                  <div style={{ marginBottom: '0.75rem' }}>
                    <label style={{ fontSize: '0.75rem', fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 }}>Conta Financeira *</label>
                    <div style={{ display: 'flex', gap: '0.4rem', alignItems: 'center' }}>
                      <input
                        type="text" value={finContaCod} placeholder="Código"
                        onChange={e => { setFinContaCod(e.target.value); setFinContaNome('') }}
                        onBlur={() => buscarConta(finContaCod)}
                        style={{ width: 80, border: `1px solid ${finContaCod.trim() ? '#d1d5db' : '#fca5a5'}`, borderRadius: 4, padding: '5px 8px', fontSize: '0.85rem' }}
                      />
                      <div style={{ flex: 1, position: 'relative' }}>
                        {finContaNome ? (
                          <div style={{ display: 'flex', alignItems: 'center', border: '1px solid #6ee7b7', borderRadius: 4, padding: '5px 8px', background: '#f0fdf4', fontSize: '0.85rem' }}>
                            <span style={{ flex: 1, color: '#065f46', fontWeight: 600 }}>{finContaNome}</span>
                            <button onClick={() => { setFinContaCod(''); setFinContaNome(''); setFinContaBusca('') }}
                              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9ca3af', padding: '0 2px', fontSize: '1rem', lineHeight: 1 }}>×</button>
                          </div>
                        ) : (
                          <>
                            <input
                              type="text" value={finContaBusca} placeholder="Digite para buscar..."
                              onChange={async e => {
                                const v = e.target.value; setFinContaBusca(v)
                                if (v.length >= 2) {
                                  try {
                                    const r = await api.get('/erp/contas', { params: { busca: v } })
                                    setFinContaResultados(r.data); setFinContaAberto(r.data.length > 0)
                                  } catch { /* */ }
                                } else { setFinContaResultados([]); setFinContaAberto(false) }
                              }}
                              style={{ width: '100%', boxSizing: 'border-box', border: '1px solid #d1d5db', borderRadius: 4, padding: '5px 8px', fontSize: '0.85rem' }}
                            />
                            {finContaAberto && finContaResultados.length > 0 && (
                              <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 50, background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxHeight: 180, overflowY: 'auto' }}>
                                {finContaResultados.map(c => (
                                  <div key={c.dep_cod} onClick={() => {
                                    setFinContaCod(c.dep_cod.trim()); setFinContaNome(c.dep_des)
                                    setFinContaBusca(''); setFinContaResultados([]); setFinContaAberto(false)
                                  }} style={{ padding: '6px 10px', cursor: 'pointer', fontSize: '0.82rem', borderBottom: '1px solid #f3f4f6' }}
                                    onMouseEnter={e => (e.currentTarget.style.background = '#f0fdf4')}
                                    onMouseLeave={e => (e.currentTarget.style.background = '')}>
                                    <span style={{ fontFamily: 'monospace', color: '#6b7280', marginRight: 8 }}>{c.dep_cod.trim()}</span>{c.dep_des}
                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Parcelas calculadas */}
                  {finParcelas.length > 0 && (
                    <div>
                      <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#374151', textTransform: 'uppercase', marginBottom: 5 }}>Parcelas</div>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                        <thead>
                          <tr className="thead-claro" style={{ background: '#f9fafb' }}>
                            {['Nº', 'Vencimento', 'Valor'].map(h => (
                              <th key={h} style={{ padding: '3px 8px', border: '1px solid #e5e7eb', color: '#9ca3af', fontWeight: 600, textAlign: h === 'Nº' ? 'center' : 'right' }}>{h}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {finParcelas.map((p, i) => (
                            <tr key={i}>
                              <td style={{ padding: '3px 8px', border: '1px solid #e5e7eb', textAlign: 'center' }}>{p.numero}</td>
                              <td style={{ padding: '3px 8px', border: '1px solid #e5e7eb', textAlign: 'right' }}>{fmtData(p.vencimento)}</td>
                              <td style={{ padding: '3px 8px', border: '1px solid #e5e7eb', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtMoeda(parseFloat(p.valor))}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {finParcelas.length === 0 && (
                    <button
                      onClick={() => recalcularParcelas(finQtd, finIntervalo, finRow)}
                      style={{ width: '100%', padding: '7px', background: '#f0fdf4', border: '1px dashed #6ee7b7', borderRadius: 4, fontSize: '0.82rem', color: '#065f46', cursor: 'pointer', fontWeight: 600 }}>
                      Calcular parcelas
                    </button>
                  )}

                  {finErro && (
                    <div style={{ marginTop: '0.75rem', fontSize: '0.8rem', color: '#dc2626', background: '#fee2e2', borderRadius: 4, padding: '0.4rem 0.75rem' }}>
                      {finErro}
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Rodapé */}
            <div style={{ borderTop: '1px solid #e5e7eb', padding: '0.65rem 1.25rem', display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', background: '#f9fafb' }}>
              <button onClick={fecharFinanceiro} disabled={finSalvando} style={{ padding: '5px 16px', background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, fontSize: '0.82rem', cursor: 'pointer', color: '#6b7280' }}>
                Fechar
              </button>
              <button
                onClick={salvarFinanceiroNfse}
                disabled={finSalvando || finParcelas.length === 0 || !finContaCod.trim()}
                style={{
                  padding: '5px 18px', background: '#065f46', color: '#fff', border: 'none',
                  borderRadius: 4, fontSize: '0.82rem', fontWeight: 600,
                  cursor: finSalvando || finParcelas.length === 0 || !finContaCod.trim() ? 'not-allowed' : 'pointer',
                  opacity: finSalvando || finParcelas.length === 0 || !finContaCod.trim() ? 0.6 : 1,
                }}>
                {finSalvando ? 'Salvando...' : 'Salvar financeiro'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Resumo */}
      {consultaRow && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
          display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
          zIndex: 1000, padding: '16px 10px',
        }} onClick={fecharConsulta}>
          <div style={{
            background: '#fff', borderRadius: 8,
            width: 780, maxWidth: '97vw', maxHeight: 'calc(100vh - 32px)', overflow: 'hidden',
            display: 'flex', flexDirection: 'column',
            boxShadow: '0 24px 64px rgba(0,0,0,0.3)',
          }} onClick={e => e.stopPropagation()}>

            {/* Cabeçalho azul */}
            <div style={{
              background: '#1a6ea8', color: '#fff', flexShrink: 0,
              padding: '0.85rem 1.25rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: '1.02rem', letterSpacing: 0.2 }}>
                  NFS-e Nacional Nº {String(consultaRow.numero).padStart(9, '0')} — Série {String(consultaRow.serie).trim()}
                </div>
                <div style={{ fontSize: '0.78rem', opacity: 0.8, marginTop: 3 }}>
                  Emissão: {fmtData(consultaRow.data_emissao ?? consultaRow.data_compet)}
                  {(consultaRow.tp_amb === '2' || (consultaRow.tp_amb as any) === 2) && (
                    <span style={{ marginLeft: 10, background: '#f59e0b', color: '#1a6ea8', padding: '1px 7px', borderRadius: 4, fontWeight: 700, fontSize: '0.7rem' }}>HOMOLOGAÇÃO</span>
                  )}
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.65rem' }}>
                {(() => {
                  const sit = SIT[consultaRow.sitnfe] ?? { label: `Sit ${consultaRow.sitnfe}`, color: '#374151', bg: '#f3f4f6' }
                  return (
                    <span style={{ padding: '3px 10px', borderRadius: 12, fontSize: '0.74rem', fontWeight: 700, background: sit.bg, color: sit.color }}>
                      {sit.label}
                    </span>
                  )
                })()}
                <button onClick={fecharConsulta} style={{
                  background: 'rgba(255,255,255,0.18)', border: 'none', cursor: 'pointer',
                  color: '#fff', padding: '2px 8px', borderRadius: 4, fontSize: '1rem', lineHeight: 1,
                }}>✕</button>
              </div>
            </div>

            {/* Corpo scrollável */}
            <div style={{ overflowY: 'auto', flex: 1 }}>
              {carregandoConsulta ? (
                <div style={{ textAlign: 'center', padding: '4rem', color: '#9ca3af' }}>Carregando dados da nota...</div>
              ) : (
                <>
                  {/* ── IDENTIFICAÇÃO ── */}
                  {secTitle('Identificação')}
                  <div style={{ padding: '0.7rem 1.25rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.45rem 1.5rem', marginBottom: '0.45rem' }}>
                      {kv('Empresa', (() => { const e = empresas.find(x => x.empcod === consultaRow.empcod); return e ? `${e.empcod} - ${e.empfan || e.empnom}` : `Cód. ${consultaRow.empcod}` })())}
                      {kv('Série / Número', `${String(consultaRow.serie).trim()} / ${consultaRow.numero}`)}
                      {kv('Competência', fmtData(consultaRow.data_compet))}
                    </div>
                    {consultaRow.chave_acesso && kv('Chave de Acesso',
                      <span style={{ fontFamily: 'monospace', fontSize: '0.77rem', wordBreak: 'break-all' }}>{consultaRow.chave_acesso}</span>
                    )}
                  </div>

                  {/* ── TOMADOR ── */}
                  {secTitle('Tomador')}
                  <div style={{ padding: '0.7rem 1.25rem' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.45rem 1.5rem', marginBottom: '0.5rem' }}>
                      {kv('CNPJ / CPF', fmtCnpj(String(consultaRow.cnpj_tomador ?? '').trim()))}
                      {consultaDetalhes?.nomeToma && kv('Razão Social', consultaDetalhes.nomeToma)}
                    </div>
                    {kv('Descrição do Serviço',
                      <span style={{ fontWeight: 600 }}>{String(consultaRow.desc_serv ?? '').trim() || '—'}</span>
                    )}
                    {(consultaDetalhes?.xLocPrest || consultaDetalhes?.nNFSe) && (
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.45rem 1.5rem', marginTop: '0.45rem' }}>
                        {consultaDetalhes?.nNFSe && kv('Nº NFS-e (SEFAZ)', consultaDetalhes.nNFSe)}
                        {consultaDetalhes?.xLocPrest && kv('Local de Prestação', consultaDetalhes.xLocPrest)}
                      </div>
                    )}
                  </div>

                  {/* ── VALORES ── */}
                  {secTitle('Valores')}
                  <div style={{ padding: '0.7rem 1.25rem' }}>
                    {(() => {
                      const d = consultaDetalhes
                      const fmtV = (v: string) => v ? `R$ ${fmtMoeda(v)}` : '—'
                      const num = (v: string) => Number(v) || 0
                      return (
                        <>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.5rem 1.5rem', marginBottom: '0.75rem' }}>
                            {kv('Base de Cálculo', fmtV(d?.vBC ?? consultaRow.valor_total))}
                            {kv(`ISS (${d?.pAliqAplic ?? Number((consultaRow as any).pe_iss || 0).toFixed(2)}%)`, fmtV(d?.vISSQN ?? (consultaRow as any).vl_iss))}
                            {kv('Total Retenções', fmtV(d?.vTotalRet))}
                          </div>
                          {(num(d?.vRetCP) > 0 || num(d?.vIRRF) > 0 || num(d?.vCSLL) > 0 || num(d?.vPis) > 0 || num(d?.vCofins) > 0) && (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '0.4rem 1rem', marginBottom: '0.75rem', background: '#f9fafb', borderRadius: 4, padding: '0.5rem 0.75rem' }}>
                              {num(d?.vRetCP)   > 0 && kv('INSS/CP',  fmtV(d.vRetCP))}
                              {num(d?.vIRRF)    > 0 && kv('IRRF',     fmtV(d.vIRRF))}
                              {num(d?.vCSLL)    > 0 && kv('CSLL',     fmtV(d.vCSLL))}
                              {num(d?.vPis)     > 0 && kv('PIS',      fmtV(d.vPis))}
                              {num(d?.vCofins)  > 0 && kv('COFINS',   fmtV(d.vCofins))}
                            </div>
                          )}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '3rem' }}>
                            <div>
                              <div style={{ fontSize: '0.66rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 2 }}>Valor Bruto</div>
                              <div style={{ fontSize: '1.1rem', fontWeight: 700, color: '#374151', fontVariantNumeric: 'tabular-nums' }}>
                                R$ {fmtMoeda(consultaRow.valor_total)}
                              </div>
                            </div>
                            {d?.vLiq && (
                              <div>
                                <div style={{ fontSize: '0.66rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', marginBottom: 2 }}>Valor Líquido</div>
                                <div style={{ fontSize: '1.3rem', fontWeight: 700, color: '#15803d', fontVariantNumeric: 'tabular-nums' }}>
                                  R$ {fmtMoeda(d.vLiq)}
                                </div>
                              </div>
                            )}
                          </div>
                        </>
                      )
                    })()}
                  </div>

                  {consultaRow.xmotivo ? (
                    <>
                      {secTitle('Observação / Motivo')}
                      <div style={{ padding: '0.7rem 1.25rem' }}>
                        <div style={{ fontSize: '0.85rem', background: '#f9fafb', borderRadius: 4, padding: '0.5rem 0.75rem', color: '#374151' }}>
                          {consultaRow.xmotivo}
                        </div>
                      </div>
                    </>
                  ) : null}

                  {/* ── FINANCEIRO ── */}
                  {secTitle('Financeiro')}
                  <div style={{ padding: '0.7rem 1.25rem' }}>
                    {consultaFinanceiro.length === 0 ? (
                      <span style={{ fontSize: '0.82rem', color: '#9ca3af' }}>Nenhum financeiro lançado para esta nota.</span>
                    ) : (
                      <>
                        <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#065f46', textTransform: 'uppercase', marginBottom: 6 }}>
                          {consultaFinanceiro.length} parcela{consultaFinanceiro.length > 1 ? 's' : ''}
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.8rem' }}>
                          <thead>
                            <tr className="thead-claro" style={{ background: '#f0fdf4' }}>
                              {['Nº', 'Vencimento', 'Valor', 'Saldo', 'Conta'].map(h => (
                                <th key={h} style={{ padding: '4px 8px', border: '1px solid #bbf7d0', color: '#065f46', fontWeight: 700, textAlign: h === 'Nº' ? 'center' : 'left' }}>{h}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {consultaFinanceiro.map((p, i) => (
                              <tr key={i}>
                                <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'center' }}>{p.numero}</td>
                                <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0' }}>{fmtData(p.vencimento)}</td>
                                <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtMoeda(p.valor)}</td>
                                <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtMoeda(p.saldo)}</td>
                                <td style={{ padding: '4px 8px', border: '1px solid #bbf7d0', fontFamily: 'monospace', fontSize: '0.76rem' }}>{p.contaCod}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>

                  <div style={{ height: '0.5rem' }} />
                </>
              )}
            </div>

            {/* Rodapé */}
            <div style={{
              borderTop: '1px solid #e5e7eb', padding: '0.6rem 1.25rem',
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              background: '#f9fafb', flexShrink: 0,
            }}>
              <div>
                {consultaRow.sitnfe === 6 && (
                  <button
                    onClick={() => { const r = consultaRow; fecharConsulta(); abrirFinanceiro(r) }}
                    style={{ padding: '5px 16px', background: '#f0fdf4', color: '#065f46', border: '1px solid #6ee7b7', borderRadius: 4, fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer' }}>
                    Gerenciar Financeiro
                  </button>
                )}
              </div>
              <button className="btn btn-sm" onClick={fecharConsulta} style={{ color: '#6b7280' }}>Fechar</button>
            </div>
          </div>
        </div>
      )}

      {/* Cabeçalho */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
        <h2 style={{ fontSize: '1.1rem', fontWeight: 700, flex: 1, margin: 0 }}>
          NFS-e Nacional — Transmissão e Consulta
        </h2>
        <button className="btn btn-primary btn-sm" onClick={() => navigate('/nfse/emitir')}>
          + Nova NFS-e
        </button>
      </div>

      {/* Filtros */}
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: '0.5rem', alignItems: 'flex-end',
        background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6,
        padding: '0.6rem 0.75rem', marginBottom: '0.75rem',
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <label style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600 }}>CNPJ / NOME TOMADOR</label>
          <input style={{ ...inp, width: 200 }} placeholder="CNPJ ou nome"
            value={filtros.tomador}
            onChange={e => setFiltros(f => ({ ...f, tomador: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && pesquisar()} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <label style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600 }}>Nº DPS</label>
          <input style={{ ...inp, width: 90 }} type="number" placeholder="Número"
            value={filtros.numero}
            onChange={e => setFiltros(f => ({ ...f, numero: e.target.value }))}
            onKeyDown={e => e.key === 'Enter' && pesquisar()} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <label style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600 }}>PERÍODO DE</label>
          <input style={{ ...inp, width: 130 }} type="date"
            value={filtros.dataInicio}
            onChange={e => setFiltros(f => ({ ...f, dataInicio: e.target.value }))} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <label style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600 }}>ATÉ</label>
          <input style={{ ...inp, width: 130 }} type="date"
            value={filtros.dataFim}
            onChange={e => setFiltros(f => ({ ...f, dataFim: e.target.value }))} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <label style={{ fontSize: '0.72rem', color: '#6b7280', fontWeight: 600 }}>SITUAÇÃO</label>
          <select style={{ ...inp, width: 130 }}
            value={filtros.sitnfe}
            onChange={e => setFiltros(f => ({ ...f, sitnfe: e.target.value }))}>
            <option value="">Todas</option>
            <option value="5">Pendente</option>
            <option value="6">Autorizada</option>
            <option value="4">Rejeitada</option>
            <option value="7">Cancelada</option>
          </select>
        </div>
        <button className="btn btn-primary btn-sm" onClick={pesquisar} disabled={carregando}
          style={{ height: 30, alignSelf: 'flex-end' }}>
          {carregando ? 'Buscando...' : 'Pesquisar'}
        </button>
        <button className="btn btn-sm" onClick={limpar}
          style={{ height: 30, alignSelf: 'flex-end', color: '#6b7280' }}>
          Limpar
        </button>
      </div>

      {erro && (
        <div className="alert alert-danger" style={{ marginBottom: '0.75rem' }}>{erro}</div>
      )}
      {emailMsg && (
        <div className={`alert ${emailMsg.ok ? 'alert-success' : 'alert-danger'}`} style={{ marginBottom: '0.75rem' }}>
          {emailMsg.texto}
        </div>
      )}

      <div style={{ overflowX: 'auto' }}>
        <table className="table" style={{ fontSize: '0.82rem', minWidth: 860, borderCollapse: 'collapse' }}>
          <thead>
            <tr className="thead-claro" style={{ background: '#f9fafb', borderBottom: '2px solid #e5e7eb' }}>
              <th style={{ width: 50, textAlign: 'center' }}>Sér</th>
              <th style={{ width: 80 }}>Nº NFS-e</th>
              <th style={{ width: 160, whiteSpace: 'nowrap' }}>CNPJ Tomador</th>
              <th style={{ width: 180 }}>Tomador</th>
              <th>Descrição</th>
              <th style={{ width: 90, textAlign: 'center' }}>Competência</th>
              <th style={{ width: 110, textAlign: 'right' }}>Val. Serviço</th>
              <th style={{ width: 110 }}>Situação</th>
              <th style={{ width: 50, textAlign: 'center' }}>Amb</th>
              <th style={{ width: 130 }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {carregando && (
              <tr><td colSpan={10} style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Carregando...</td></tr>
            )}
            {!carregando && lista.length === 0 && (
              <tr><td colSpan={10} style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>Nenhuma NFS-e Nacional encontrada no período</td></tr>
            )}
            {lista.map((row, i) => {
              const sit = SIT[row.sitnfe] ?? { label: `Sit ${row.sitnfe}`, color: '#374151', bg: '#f3f4f6' }
              return (
                <tr key={i} style={{ borderBottom: '1px solid #e5e7eb', cursor: 'pointer' }} onClick={() => abrirConsulta(row)}>
                  <td style={{ textAlign: 'center', color: '#6b7280' }}>{String(row.serie).trim() || '1'}</td>
                  <td style={{ fontWeight: 700 }}>{row.numero}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: '0.78rem', whiteSpace: 'nowrap' }}>
                    {fmtCnpj(String(row.cnpj_tomador ?? '').trim())}
                  </td>
                  <td style={{ maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    title={row.nome_tomador}>
                    {row.nome_tomador || '—'}
                  </td>
                  <td style={{ maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    title={row.desc_serv}>
                    {String(row.desc_serv ?? '').trim() || '—'}
                  </td>
                  <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                    {fmtData(row.data_compet)}
                  </td>
                  <td style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums', fontWeight: 600 }}>
                    {fmtMoeda(row.valor_total)}
                  </td>
                  <td>
                    <div>
                      <span style={{
                        display: 'inline-block', padding: '2px 8px', borderRadius: 12,
                        fontSize: '0.74rem', fontWeight: 600, whiteSpace: 'nowrap',
                        background: sit.bg, color: sit.color,
                      }}>
                        {sit.label}
                      </span>
                      {row.sitnfe === 4 && row.xmotivo && (
                        <div style={{ fontSize: '0.68rem', color: '#dc2626', marginTop: 2, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                          title={String(row.xmotivo).trim()}>
                          {String(row.xmotivo).trim()}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <span style={{
                      fontSize: '0.68rem', fontWeight: 700, padding: '1px 6px', borderRadius: 4,
                      background: row.tp_amb === '1' || row.tp_amb === 1 as any ? '#dcfce7' : '#fef3c7',
                      color:      row.tp_amb === '1' || row.tp_amb === 1 as any ? '#15803d' : '#92400e',
                    }}>
                      {row.tp_amb === '1' || row.tp_amb === 1 as any ? 'Prod' : 'Hom'}
                    </span>
                  </td>
                  <td onClick={e => e.stopPropagation()}>
                    {(row.sitnfe === 5 || row.sitnfe === 4) && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start' }}>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn-sm"
                            disabled={transmitindo === row.numero}
                            onClick={() => transmitir(row)}
                            title="Reenviar ao SEFIN com os mesmos dados"
                            style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', fontWeight: 600, whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                            {transmitindo === row.numero ? '...' : 'Transmitir'}
                          </button>
                          <button className="btn btn-orange btn-sm"
                            onClick={() => navigate(`/nfse/emitir?editId=${row.numero}&empcod=${row.empcod}`)}
                            style={{ whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                            Editar
                          </button>
                          <button className="btn btn-sm"
                            onClick={() => window.open(`/api/nfse-nacional/${row.numero}/xml?empcod=${row.empcod}`, '_blank')}
                            title="Baixar XML com o retorno completo do SEFIN (inclusive erro de rejeição)"
                            style={{ background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', fontWeight: 600, whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                            Baixar XML
                          </button>
                        </div>
                        {msgTransmitir?.numero === row.numero && (
                          <div style={{ fontSize: '0.68rem', maxWidth: 200, color: msgTransmitir.ok ? '#15803d' : '#dc2626' }}
                            title={msgTransmitir.texto}>
                            {msgTransmitir.texto}
                          </div>
                        )}
                      </div>
                    )}
                    {row.sitnfe === 6 && row.chave_acesso && (
                      <>
                        <button className="btn btn-sm"
                          onClick={e => toggleMenuAcoes(e, row.numero)}
                          style={{ background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', fontWeight: 600, whiteSpace: 'nowrap', fontSize: '0.75rem' }}>
                          Ações ▾
                        </button>
                        {acoesMenuId === row.numero && acoesMenuPos && (
                          <>
                            <div onClick={fecharMenuAcoes} style={{ position: 'fixed', inset: 0, zIndex: 99 }} />
                            <div style={{
                              position: 'fixed', top: acoesMenuPos.top, left: acoesMenuPos.left,
                              zIndex: 100, background: '#fff', border: '1px solid #e5e7eb',
                              borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
                              minWidth: 190, overflow: 'hidden', padding: '4px 0',
                            }}>
                              <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); window.open(`/api/nfse-nacional/${row.numero}/xml?empcod=${row.empcod}`, '_blank') }}>
                                Baixar XML
                              </button>
                              <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); window.open(`/api/nfse-nacional/${row.numero}/pdf?empcod=${row.empcod}`, '_blank') }}>
                                Baixar DANFSe (PDF)
                              </button>
                              {row.chave_acesso && (
                                <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                  onClick={() => { fecharMenuAcoes(); copiarChave(row.chave_acesso!, row.numero) }}>
                                  {chaveCopiadaId === row.numero ? '✓ Chave copiada' : 'Copiar Chave de Acesso'}
                                </button>
                              )}
                              <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); abrirFinanceiro(row) }}>
                                Financeiro
                              </button>
                              <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); abrirEmail(row) }}>
                                Enviar por e-mail
                              </button>
                              <button style={menuItemStyle} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); navigate(`/nfse/emitir?copyId=${row.numero}&empcod=${row.empcod}`) }}>
                                Copiar (nova nota)
                              </button>
                              <button style={{ ...menuItemStyle, color: '#dc2626', borderTop: '1px solid #f3f4f6' }} onMouseEnter={onMenuHover} onMouseLeave={onMenuLeave}
                                onClick={() => { fecharMenuAcoes(); setRowCancel(row); setXJust(''); setErroCancel(null); setCMotivo(1) }}>
                                Cancelar NFS-e
                              </button>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
